export const STATUS_CHANGE_REASONS = {
  REJECTED_NOT_QUALIFIED: 1,
  REJECTED_PREVIOUSLY_WORKED_HERE: 2,
  REJECTED_DIDNT_RESPOND: 3,
  REJECTED_INTERVIEW_SALARY: 4,
  REJECTED_INTERVIEW_OTHER: 5,
  REJECTED_NOT_QUALIFIED_PHONE_SCREEN: 6,
  REJECTED_DIDNT_SHOW: 7,
  REJECTED_TURNED_DOWN_OFFER: 8,
  REJECTED_NOT_QUALIFIED_SKILLS: 9,
  REJECTED_NOT_QUALIFIED_CULTURE: 10,
  REJECTED_QUIT: 11,
  REJECTED_DIDNT_SHOW_FIRST_DAY: 12,
  REJECTED_FIRED_FIRST_MONTH: 13,
  REJECTED_FIRED: 14,
  REJECTED_OTHER: 15,
  ARCHIVED_NOT_QUALIFIED: 16,
  ARCHIVED_PREVIOUSLY_WORKED_HERE: 17,
  ARCHIVED_EXPIRED: 18,
  ARCHIVED_NOT_ENOUGH_INFO: 19,
  REJECTED_LANGUAGE_BARRIER: 20,
  REJECTED_TOO_FAR_AWAY: 21,
  ACCEPTED_REJECTED_TOOK_ANOTHER_JOB: 22,
  INTERVIEWING_REJECTED_TOOK_ANOTHER_JOB: 23,
  VALIDATING_REJECTED_TOOK_ANOTHER_JOB: 24,
  REJECTED_FAILED_BACKGROUND_CHECK: 25,
  REJECTED_FAILED_INSURANCE_CHECK: 26,
  VALIDATING_REJECTED_DIDNT_RESPOND: 27,
  ARCHIVED_OTHER: 28,
  APPLIED_ARCHIVED_PAY_EXPECTATION_TOO_HIGH: 29,
  APPLIED_ARCHIVED_OPTED_OUT_OF_TEXTS: 30,
  ACCEPTED_ARCHIVED_OPTED_OUT_OF_TEXTS: 31,
  VALIDATING_REJECTED_FAILED_CUSTOM_FINALIZING_HIRE_STEP: 35,
  APPLIED_ARCHIVED_LIVES_TOO_FAR_AWAY: 38,
  APPLIED_REJECTED_PAY_EXPECTATION_TOO_HIGH: 39,
  APPLIED_REJECTED_NOT_ENOUGH_INFORMATION: 40,
  APPLIED_REJECTED_LIVES_TOO_FAR_AWAY: 41,
  APPLIED_REJECTED_JOB_HOPPER: 42,
  REJECTED_ACCEPTED_ANOTHER_JOB: 43,
  APPLIED_REJECTED_ALREADY_APPLIED: 44,
  PHONE_INTERVIEWING_REJECTED_DIDNT_ANSWER: 45,
  PHONE_INTERVIEWING_REJECTED_NOT_QUALIFIED_SKILLS: 46,
  PHONE_INTERVIEWING_REJECTED_NOT_QUALIFIED_BAD_CULTURE_FIT: 47,
  APPLIED_SAVED_DESIRED_SHIFT_UNAVAILABLE: 48,
  APPLIED_SAVED_PAY_EXPECTATION_TOO_HIGH: 49,
  SAVED_ACCEPTED_ANOTHER_JOB: 50,
  SAVED_RELOCATING_AT_A_LATER_DATE: 51,
  SAVED_NO_LONGER_HIRING: 52,
  SAVED_OTHER: 55,
  SAVED_BETTER_FIT_FOR_ANOTHER_POSITION: 56,
  SAVED_MISSING_QUALIFICATIONS: 57,
};
